<template>
  <v-row dense>
    <v-col cols="3">
      <v-text-field
        v-model="internalValue.code"
        outlined
        label="登録番号"
        :error-messages="error.code"
        dense />
    </v-col>
    <v-col cols="3">
      <date-picker
        v-if="value.type === 1"
        v-model="internalValue.registration_date"
        :error-messages="error.registration_date"
        label="登録日" />
    </v-col>
    <v-col cols="3">
      <date-picker
        v-if="value.type === 1"
        v-model="internalValue.expiration_date"
        :error-messages="error.expiration_date"
        label="有効期限" />
      <date-picker
        v-else
        v-model="internalValue.expiration_date"
        :error-messages="error.expiration_date"
        label="修了年月日" />
    </v-col>
    <v-col cols="3">
      <v-btn
        v-if="(value.type === 1 && !isProfilePage && $store.state.auth.permission >= 2)
          || (value.type === 1 && isProfilePage)"
        :disabled="!internalValue.expiration_date"
        color="primary"
        @click.prevent="onExpirationDateUpdateClicked">
        更新
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>

import DatePicker from '../DatePicker'

export default {
  name: 'LicenseTextFields',
  components: { DatePicker },
  props: {
    value: {
      type: Object,
      default: () => ({ code: null, registration_date: null, expiration_date: null }),
    },
    error: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isProfilePage() {
      return window.location.href.includes('/profile')
    },
    internalValue: {
      get() {
        return this.value ?? {}
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    onExpirationDateUpdateClicked() {
      const selectedDate = new Date(this.value.expiration_date)
      selectedDate.setFullYear(selectedDate.getFullYear() + 1)
      this.internalValue.expiration_date = selectedDate.toISOString()
    },
  },
}
</script>
